import { FC } from 'react';
import { CheckOutlined } from '@ant-design/icons';

import { STEPS } from '../CourseEnrollment.const';
import css from '../CourseEnrollment.module.css';

interface Props {
  step: number;
}

const Stepper: FC<Props> = ({ step }) => (
  <div className={css.Stepper}>
    {STEPS.map((s, idx) => {
      const isActive = s.id === step;
      const isDone = s.id < step;
      return (
        <div
          key={s.id}
          className={`${css.StepItem} ${isActive ? css.StepItemActive : ''}`}
        >
          <span
            className={`${css.StepCircle} ${
              isActive ? css.StepCircleActive : ''
            } ${isDone ? css.StepCircleDone : ''}`}
          >
            {isDone ? <CheckOutlined /> : s.id}
          </span>
          <span
            className={`${css.StepLabel} ${
              isActive ? css.StepLabelActive : ''
            }`}
          >
            {s.id}. {s.label}
          </span>
          {idx < STEPS.length - 1 && <span className={css.StepConnector} />}
        </div>
      );
    })}
  </div>
);

export default Stepper;
